module.exports = __webpack_public_path__ + "assets/img/HR-Connect-Website.0985ce6d.jpg";